module.exports = __webpack_public_path__ + "img/2_125.ec022667.png";